export const FETCH_MOVIES = "movies/fetch";
export const FETCH_ONE_MOVIE = "movies/fetch-one-movie";
export const FETCH_GENRES = "genres/fetch";
// export const baseUrl = "http://localhost:8000";
export const baseUrl = "https://rotten-berries.herokuapp.com";
